import useMDXLayout from 'developer-docs-shared-components/hooks/useMDXLayout';
import { useViewport } from 'developer-docs-shared-components/hooks/useViewport';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { useMemo } from 'react';
import useUniqueId from 'react-utils/hooks/useUniqueId';
import styled from 'styled-components';
import GutterContainer from './GutterContainer';
import { jsx as _jsx } from "react/jsx-runtime";
// We want to maintain the existing spacing between p, div, and ul elements, except for the last child
// See discussion: https://git.hubteam.com/HubSpot/developer-docs-ui/pull/2707#discussion_r3887291
const AlertContent = styled.div.withConfig({
  displayName: "Alert__AlertContent",
  componentId: "sc-1m754uz-0"
})(["div,p,ul{&:last-child{margin-bottom:", ";}}"], ({
  theme
}) => theme.space['0']);

/**
 * Based on [UIAlert](https://tools.hubteamqa.com/ui-library/show/UIComponents/alert/UIAlert). Uses the same `type` to render as a different background
 * color, depending on its content.
 *
 * @see https://tools.hubteamqa.com/ui-library/show/UIComponents/alert/UIAlert
 */
const MDXAlert = ({
  children,
  size = 'medium',
  type = 'info',
  titleText
}) => {
  const isMDXLayout = useMDXLayout();
  const viewportCtx = useViewport();
  const id = useUniqueId('mdx-alert');
  const props = useMemo(() => {
    const isDesktop = viewportCtx && viewportCtx.isDesktop;
    return {
      type,
      use: 'inline',
      paddingBlock: '600',
      paddingInline: '800',
      marginInline: '0',
      marginBlock: isDesktop ? isMDXLayout ? '800' : '200' : '400' // 16px default
    };
  }, [isMDXLayout, type, viewportCtx]);
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx(GutterContainer, {
      size: size,
      children: /*#__PURE__*/_jsx(Alert, Object.assign({
        id: id
      }, props, {
        titleText: titleText,
        children: /*#__PURE__*/_jsx(AlertContent, {
          children: children
        })
      }))
    })
  );
};
export default MDXAlert;